import React,{useState} from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import {social_link} from "../../config/custom";

function HeaderTop(props) {
  const [showMessage,setShowMessage] = useState(true);
  return (
    <section className="headerTopWrap">
      {(moment().month() <= 3 && !localStorage.getItem("authToken") && showMessage) &&
        <div className="row">
          <div className="col-12">
              <div className="bg-dark text-light text-center"  style={{"padding":"15px 61px 13px 10px","font-size":"17px"}}>Limited-Time Offer: Double your value, pay half the price! Sign up before April 30th, 2024, and get two months' access for the price of one, plus a 7-day free trial. &nbsp;&nbsp; <span className="btn btn-info" style = {{
    "position": "absolute",
    "right": "38px",
    "top": "6px"
}} onClick={()=>{setShowMessage(!showMessage)}}>X</span></div> 
          </div>
        </div>
      }
      <div className="container">
        <div className="row">
          <div className="col-sm-6">
            <ul className="socialIcon">
            {social_link.map((item,i)=>{
             return (<li key={i}>
              <a href={item.link} target="_blank">
                <i className={item.class_name} aria-hidden="true"></i>
              </a>
            </li>)
            })}
            </ul>
          </div>
          <div className="col-sm-6">
            <div className="topbarAction text-right">
            <Link to="/registration"><i className="fa fa-id-badge"></i> Join As Coach</Link>
            <Link to="/login"><i className="fa fa-user"></i> &nbsp;Login</Link>
            <Link className="btn btn-default defaultBtn" style={{"padding":"10px 10px 10px 0px"}} to="/user_registration"><span className="fa fa-id-badge"></span> Sign Up</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default HeaderTop;
